export default function Section({ children }) {
  return (
    <div className="mt-3 [&_*]:text-left sm:[&_*]:text-justify [&_*]:text-over-primary-background [&_*]:font-light [&>h2]:text-primary [&>h2]:leading-6 [&>h2]:mb-1 [&>h2]:text-primary [&>h2]:font-medium [&>h2]:text-2xl [&_ul_p]:text-xs [&_ul]:list-disc [&_ul]:text-xs [&_ul]:pl-8 [&_p]:text-sm [&_p]:mb-3">
      {children}
    </div>
  )
}
